module.exports = __webpack_public_path__ + "36d8e29942e50defe0422182a3632cbb.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/heros/scalable-process.svg
// module id = 634
// module chunks = 0